import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

/**
 * Inizializzazione client Supabase.
 *
 * Le chiavi DEVONO arrivare via env vars Vite (`VITE_SUPABASE_URL` e
 * `VITE_SUPABASE_ANON_KEY`). Storicamente c'erano fallback hardcoded che
 * avevano coperto un bug nascosto: il sito girava anche senza env vars
 * configurate, perché usava i valori del repo. Rimossi per:
 *
 *  - non distribuire chiavi nel bundle GitHub pubblico
 *  - rendere esplicito il fail quando l'ambiente non è settato
 *
 * La chiave `anon` è comunque pensata per essere pubblica nel bundle browser:
 * tutti gli accessi al DB sono filtrati lato Postgres dalle Row Level Security
 * policies. La SERVICE_ROLE_KEY (che bypassa RLS) NON va MAI nel frontend.
 */
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  // Throw early: meglio crash visibile al boot che query silenziose che falliscono.
  // In locale: copia `.env.example` in `.env` e popola le 2 chiavi.
  // Su Vercel: Settings → Environment Variables → aggiungi VITE_SUPABASE_URL
  // e VITE_SUPABASE_ANON_KEY (vedi docs/DECISIONS.md).
  throw new Error(
    'Configurazione Supabase mancante: VITE_SUPABASE_URL e/o VITE_SUPABASE_ANON_KEY ' +
    'non sono definite. In locale crea un .env (vedi .env.example). ' +
    'Su Vercel impostale in Settings → Environment Variables.',
  );
}

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
